export class SysMenus {
    constructor(){
        this.IsHome = false;
        this.IsMainMenu = false;
        this.Component = "";
        this.isDisplayMenus=true;
    }
    /**
     * 组件名称
     */
    Component: string;
    /**
     * 菜单图标
     */
    Icon: string;
    /**
     * 页面对应的ConfigName名称
     */
    PageName: string;
    /**
     * 排序
     */
    SortLevel: number;
    /**
     * 菜单名称
     */
    Title: string;
    /**
     * 路由地址
     */
    Url: string;
    /**
     * 是否为首页
     */
    IsHome: boolean;
    /**
     * 是否主菜单
     */
    IsMainMenu: boolean;
    /**
     * 表示是否存在外部链接,以Http开头
     */
    webUrl:string;
    /**
     * 表示是否菜单显示，默认显示  true
     */
    isDisplayMenus:boolean;
    /**
     * 菜单列表
     */
    menus: Array<SysMenus> = new Array<SysMenus>();
}